import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./FlexCol.scss";

export class FlexCol extends React.Component {
  static defaultProps = {
    justifyContent: "flex-start",
    alignItems: "flex-start",
  };

  static propTypes = {
    alignItems: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    flexSpacing: PropTypes.number,
    justifyContent: PropTypes.string,
    gap: PropTypes.oneOf(["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"]),
  };

  render() {
    const {
      alignItems,
      children,
      className,
      flexSpacing,
      gap,
      justifyContent,
    } = this.props;
    const FlexColClass = classNames(
      "FlexCol",
      gap && `FlexCol--gap${gap}`,
      className
    );

    return (
      <div
        className={FlexColClass}
        style={{ flex: flexSpacing, justifyContent, alignItems }}
      >
        {children}
      </div>
    );
  }
}

export default FlexCol;
